export function isValidEnumValue(
  enumObject: Record<string, unknown>,
  value?: number | string
) {
  const keys = Object.keys(enumObject);
  for (const key of keys) {
    // enum의 값이 숫자이면 두 개 씩 들어간다.
    // 이때 키와 값이 반대로 들어간 경우는 무시한다.
    if (
      typeof enumObject[key] === 'string' &&
      enumObject[(enumObject as any)[key]]
    ) {
      continue;
    }
    if (enumObject[key] === value) {
      return true;
    }
  }
  return false;
}
